import { render, staticRenderFns } from "./DailyReportComponent.vue?vue&type=template&id=2086e204&scoped=true&"
import script from "./DailyReportComponent.vue?vue&type=script&lang=js&"
export * from "./DailyReportComponent.vue?vue&type=script&lang=js&"
import style0 from "./DailyReportComponent.vue?vue&type=style&index=0&id=2086e204&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2086e204",
  null
  
)

export default component.exports